@let isDirty = $formIsDirty();
@let isInvalid = $formIsInvalid();
<h2 mat-dialog-title>
  {{ dialogData.title }}
  @if (isDirty) {
    <div>
      <span style="color: #f44336; font-size: 0.6em; margin-left: 8px">(Unsaved Changes)</span>
    </div>
  }
</h2>
<mat-dialog-content>
  <div style="margin-top: 10px">
    <ng-container #formComponentRef></ng-container>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-button
    (click)="handleCancel()"
  >
    {{ dialogData.closeLabel }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="handleSave()"
    [disabled]="isInvalid"
  >
    {{ dialogData.submitLabel }}
  </button>
</mat-dialog-actions>
